<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script lang="ts">
export interface FlexChildProps {
  grow?: true | number | undefined
  shrink?: true | number | undefined
  basis?: number | string | undefined

  placementEnd?: boolean | undefined
  alignment?: 'start' | 'end' | 'center' | undefined
}
</script>

<script setup lang="ts">
import { Slot } from 'reka-ui'
import { computed } from 'vue'

const {
  grow = false,
  shrink = false,
  basis: rawBasis = undefined,
  placementEnd = undefined,
  alignment = undefined,
} = defineProps<FlexChildProps>()

defineSlots<{ default: () => unknown }>()

const basis = computed(() => {
  return typeof rawBasis !== 'undefined'
    ? rawBasis && typeof rawBasis === 'number'
      ? `${rawBasis}px`
      : rawBasis
    : 'auto'
})

const flex = computed(() => `${grow ? +grow : 0} ${shrink ? +shrink : 0} ${basis.value}`)
</script>

<template>
  <Slot :class="[placementEnd && `flex-child-end`, !!alignment && `flex-child-align-${alignment}`]" :style="{ flex }">
    <slot />
  </Slot>
</template>

<style>
.flex-column .flex-child-end {
  margin-top: auto;
}

.flex-column-reversed .flex-child-end {
  margin-bottom: auto;
}

.flex-row .flex-child-end {
  margin-left: auto;
}

.flex-row-reversed .flex-child-end {
  margin-right: auto;
}
</style>
